/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react';
import queryString from 'query-string';
import Helmet from 'react-helmet';
import { Container, Row, Col } from 'reactstrap';

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import bgGradient from './img/bg-gradient.gif';
import favicon from './img/favicon.ico';
import logo from './img/logo.png';
import LoginForm from './LoginForm';

class Login extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    props.changeDefaultLocale('pt-BR');
  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    // document.body.className = 'ant-body';
    document.title = 'Watch | Ingresar';
  }

  render() {
    const { translate } = this.props;

    return (
      <Container fluid={true} className="watch-body">
        <Helmet>
          <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        </Helmet>
        <Row>
          <Col className="p-0">
            <img src={bgGradient} alt="gradient" className="gradient" />
          </Col>
        </Row>
        <Row>
          <Col>
            <img src={logo} alt="logo" className="text-left logo-watch" />
          </Col>
        </Row>
        <Row>
          <Col></Col>
          <Col>
            {
              this._validateParams()
                ? <LoginForm
                  api={this.api}
                  location={this.props.location}
                />
                : <RequestLoginErrorMessage
                  onlyMessage={true}
                  message={translate('RequestLoginErrorMessage')}
                />
            }
          </Col>
          <Col></Col>
        </Row>
      </Container>
    );
  }
}

export default WithLocalize(Login);
